import type { GroupId, ISchedulerTask, ISODate } from '@interfaces/IScheduler';

/** The draft a "new task" drawer opens on. `today` is the SITE's calendar day
 *  (`useSiteToday`) — the same day the Gantt's today line draws — so a new task
 *  lands where the presenter sees "today", whatever the browser's zone. */
export function newTaskTemplate(groupId: GroupId, today: ISODate, prefill?: Partial<ISchedulerTask>): ISchedulerTask {
  const base: ISchedulerTask = {
    id: `t-${crypto.randomUUID()}`,
    groupId,
    name: '',
    start: today,
    end: today,
    isMilestone: false,
    status: 'planned',
    kind: 'field',
    committed: false,
    progressPercent: 0,
  };
  if (!prefill) return base;
  // Spreading `prefill` threads through structural fields the caller set —
  // notably `parentId` for a sub-task (from the "Add sub-task" row action). The
  // base template has no `parentId`, so a top-level task stays parentId-absent.
  const merged: ISchedulerTask = { ...base, ...prefill };
  // Always re-issue id so the new task has a fresh one even if the caller copied an existing one.
  merged.id = base.id;
  // If milestone, collapse the end date to the start date.
  if (merged.isMilestone) merged.end = merged.start;
  return merged;
}
